var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import omit from '../_util/omit';
function OptGroup(props, ref) {
    var prefixCls = props.prefixCls, label = props.label, rest = __rest(props, ["prefixCls", "label"]);
    return (React.createElement("li", __assign({ ref: ref, className: prefixCls + "-group-title" }, omit(rest, ['_key', 'children', 'isSelectOptGroup'])), label));
}
var OptGroupComponent = React.forwardRef(OptGroup);
OptGroupComponent.defaultProps = {
    // private use
    isSelectOptGroup: true,
};
export default OptGroupComponent;
